export enum SettingsComponentType {
  Grid = 1,
  Layout = 2,
  Fields = 3,
  Selectors = 4,
  Notification = 5,
  Map = 6,
  ConfigurableFilters = 7,
}
